import React, { useEffect, useState } from 'react';
import { TextField, Autocomplete } from '@mui/material';
import ObtenerPaises from '../functions/ObtenerPaises';
import PaisSeleccionar from '../types/PaisSeleccionar';


interface SeleccionarPaisProps {
    paisInicial: number;
    onChange: (pais: PaisSeleccionar) => void;
    onClear: () => void;
    eliminando: boolean;
  }

const SeleccionarPais: React.FC<SeleccionarPaisProps> = ({ paisInicial, onChange, onClear, eliminando }) => {

    const [paises, setPaises] = useState<PaisSeleccionar[]>([]);
    const [paisSeleccionado, setPaisSeleccionado] = useState<PaisSeleccionar | null>({id: 0, iso_code: '', tel_code: '', name: ''});

    const handlePaisChange = (event: React.SyntheticEvent, newValue: PaisSeleccionar | null) => {
        if (newValue === null) {
            setPaisSeleccionado(null);
            if (onClear) {
                onClear();
            }
            return;
        }
        setPaisSeleccionado(newValue);
        if (onChange) {
            onChange(newValue);
        }

        if (newValue === null && onClear) {
            onClear();
        }
    };

    const fetchPaises = async () => {
        const data = await ObtenerPaises();
        const paisesRecuperados: PaisSeleccionar[] = [];
        
    
        for (const pais of data.paises) {
            paisesRecuperados.push({
                id: pais.id,
                iso_code: pais.codigo_iso,
                tel_code: pais.codigo_telefonico,
                name: pais.nombre
            });
        }
        setPaises(paisesRecuperados);        

        if (paisInicial > 0) {
            const paisInicio = data.paises.find(
                (p: PaisSeleccionar) => p.id === paisInicial
            );
            if (paisInicio) {
                const paisInicioOK: PaisSeleccionar = {
                    id: paisInicio.id,
                    iso_code: paisInicio.codigo_iso,
                    tel_code: paisInicio.codigo_telefonico,
                    name: paisInicio.nombre
                };
                setPaisSeleccionado(paisInicioOK);
                onChange(paisInicioOK);
            }
        }
    };

    useEffect(() => {
        fetchPaises();
    }, []);

    useEffect(() => {
        fetchPaises();
    }, [paisInicial]);

    return (
        <div className="flex flex-col w-full ">
            <Autocomplete<PaisSeleccionar>
                options={paises}
                getOptionLabel={(option: PaisSeleccionar) => `${option.name} (${option.iso_code}) +[${option.tel_code}]`}
                renderInput={(params) => <TextField {...params} label="Selecciona un país" />}
                value={paisSeleccionado}
                onChange={handlePaisChange}
                isOptionEqualToValue={(option: PaisSeleccionar, value: PaisSeleccionar) => option.id === value.id}
                renderOption={(props, option: PaisSeleccionar) => (
                <li {...props}>
                    {option.name} ({option.iso_code}) +[{option.tel_code}]
                </li>
                )}
                disabled={eliminando}
                size="small"
            />
        </div>
    );
}

export default SeleccionarPais;